import Product from "../product";


class SEO {
    run() {
        this.plp();
        this.breadcrumbs();
        this.filters();
        this.homepage();
        this.checkout();
        this.changecountry();
        this.socialshare();
        this.newsletter();
        this.wishlist();
        this.myaccount();
        this.productImpressions();
        this.asyncProductImpressions();
    }

    productImpressions() {
        var productTiles = $('.product-tile').not('.tracked');
        var _this = this;
        if (listingProductsArrayForHomePage && productTiles.length > 0) {
            productTiles.each(function () {
                var currentElement = $(this);
                var impression = _this.generateProductTrackingModel(currentElement);

                // Before adding an item to the listingProductsArrayForHomePage array,
                // check if already exists and avoid duplicates.
                if ((listingProductsArrayForHomePage.findIndex(item => item.id === impression.id) == '-1') && !currentElement.hasClass('tracked')) {
                    listingProductsArrayForHomePage.push(impression);
                    listingProductsJson[currentElement.attr('data-pid')] = impression;
                    $('.product-tile[data-pid="' + currentElement.attr('data-pid') + '"]').addClass('tracked');
                }
            });
        }
    }

    asyncProductImpressions() {
        var _this = this;
        $(window).on('gtmAsyncTrack::impression', function () {
            _this.viewItemListGA4Event();
        });
    }

    viewItemListGA4Event(){
        var _this = this;
        var productTiles = $('.product-tile').not('.tracked');
        var asyncProductsArray = [];
        if (productTiles.length > 0) {
            productTiles.each(function () {
                var currentElement = $(this);
                if(!currentElement.hasClass('impression')) {
                    var impression = _this.generateProductTrackingModel(currentElement);

                    // Before adding an item to the asyncProductsArray array,
                    // check if already exists and avoid duplicates.
                    if ((asyncProductsArray.findIndex(item => item.id === impression.id) == '-1') && !currentElement.hasClass('tracked')) {
                        asyncProductsArray.push(impression);
                        $('.product-tile[data-pid="' + currentElement.attr('data-pid') + '"]').addClass('tracked');
                    }
                }
            });
            _this.asyncProductsArray = asyncProductsArray;
        }

        if (typeof currentCurrency !== 'undefined' && asyncProductsArray.length > 0) {
            let items = [];
            let productCurrency = currentCurrency;

            asyncProductsArray.forEach(function (product) {
                if (product.category) {
                    let categories = product.category.split("/");
                    let item = {
                        item_id: product.id,
                        item_name: product.name,
                        currency: productCurrency,
                        discount: product.discount,
                        index: product.position,
                        item_brand: 'twinset milano',
                        item_category: categories.length > 0 ? categories[0] : '',
                        item_category2: categories.length > 1 ? categories[1] : '',
                        item_category3: categories.length > 2 ? categories[2] : '',
                        item_list_name: categoryPLP,
                        item_variant: product.colorName,
                        price: parseFloat((Number(product.price) - Number(product.discount)).toFixed(2)),
                        quantity: 1,
                        item_availability: product.available,
                        item_discount_tag: product.discount != 0 ? 'on_sale' : 'not_on_sale',
                        available_size_percentage: product.available_size_percentage,
                        item_size: '',
                        item_url: product.url,
                        item_img: product.imageUrl
                    }
                    items.push(item);
                }
            });

            function chunkArray(array, chunkSize) {
                const results = [];
                for (let i = 0; i < array.length; i += chunkSize) {
                    results.push(array.slice(i, i + chunkSize));
                }
                return results;
            }

            // Suddividi l'array in gruppi di massimo 15 elementi
            const chunks = chunkArray(items, 15);

            // Itera sui gruppi e inviali al dataLayer
            chunks.forEach(function(chunk) {
                var event = {
                    event: 'view_item_list',
                    ecommerce: {
                        currency: currentCurrency,
                        items: chunk
                    }
                };
                dataLayer.push(event);
            });
        }
    }

    generateProductTrackingModel(element) {
        var product = {};
        var data = element.data();

        product.name = data.name;

        // TR-2126
        // product.id = element.parent().data('pid');
        product.id = element.data('pid');
        product.variantID = element.data('container');

        if(element.find('.price-wrapper').data('plist')){
            var fullPrice = element.find('.price-wrapper').data('plist');
            var salesPrice = element.find('.price-wrapper').data('pmin');
        }else{
            var fullPrice = element.find('.price-wrapper').data('pmin');
            var salesPrice = element.find('.price-wrapper').data('pmin');
        }


        product.price = fullPrice;
        product.discount = Number((fullPrice - salesPrice).toFixed(2));
        product.available = element.data('item_availability');
        product.available_size_percentage = Number(element.data('available_size_percentage'));
        product.brand = 'twinset milano';
        product.category = element.data('category');
        product.url= element.data('master_url');
        product.imageUrl= element.data('default_color_image');
        product.colorName = element.data('color_name')
        product.position = data.pos;
        if (!product.position) {
            product.position = element.parent().parent().index() + 1;
        }

        if (typeof catListingSearch !== 'undefined') {
            product.list = catListingSearch;
        }
        if (typeof pageTypeForJS !== 'undefined') {
            if (pageTypeForJS == 'home') {
                product.list = 'homepage';
            }
            if (pageTypeForJS == 'plp') {
                product.list = 'plp';
            }
            if (pageTypeForJS == 'pdp' && element.parents('.recommendations').length) {
                product.list = 'related_products';
            }
            if (pageTypeForJS == 'cart' && element.parents('.recommendations').length) {
                product.list = 'related_products_cart';
            }
        }
        if (!product.list && element.parents('.recommendations').length) {
            product.list = 'related_products';
        }

        return product;
    }

    generateProductTrackingModelWishlist(element) {
        var product = {};
        var data = element.data();

        let categories = element.data('category').split("/");

        product.currency = element.data('currency');
        product.item_name = data.name;
        product.item_id = element.data('pid').split('_')[0];
        product.discount = Number((Number(element.data('list_price')) - Number(element.data('price'))).toFixed(2));
        product.price = Number(element.data('list_price'));
        product.brand = 'twinset milano';
        product.item_category = categories.length > 0 ? categories[0] : '';
        product.item_category2 = categories.length > 1 ? categories[1] : '',
        product.item_category3 = categories.length > 2 ? categories[2] : '',
        product.item_variant = element.data('variant-color');
        product.item_size= element.data('variant-size');
        product.item_availability = element.data('item_availability');
        product.item_discount_tag = element.data('item_discount_tag');
        product.quantity = 1;
        product.item_variant_v2 = element.data('pid');
        product.available_size_percentage= Number(element.data('available_size_percentage'));
        product.item_img = element.data('default-color-image');
        product.item_url= element.data('master-url');

        if (typeof catListingSearch !== 'undefined') {
            product.item_list_name = catListingSearch;
        }
        if (typeof pageTypeForJS !== 'undefined') {
            if (pageTypeForJS == 'home') {
                product.item_list_name = 'homepage';
            }
            if (pageTypeForJS == 'wishlist') {
                product.item_list_name = 'wishlist';
            }
            if (pageTypeForJS == 'pdp' && element.parents('.recommendations').length) {
                product.item_list_name = 'related_products';
            }
            if (pageTypeForJS == 'cart' && element.parents('.recommendations').length) {
                product.item_list_name = 'related_products_cart';
            }
        }
        if (!product.item_list_name && element.parents('.recommendations').length) {
            product.item_list_name = 'related_products';
        }

        return product;
    }

    myaccount() {
        $('.my-account-side-nav a.link').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'my_account',
                event_action: $(this).html() // TODO: missing id, using innerHTML
            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });
    }

    wishlist() {
        var _this = this;
        $('button.add-to-wishlist-modal, button.add-to-wish-list').on('click', function (e) {
            var variantID = $('.wishlist-list-size li.selected').attr('data-id');

            var item_list_name = getPageType($('.js-page').data('action'), this);
            trackForWish(
                $(e.target).closest('.modal').data('url'),
                $(e.target).hasClass('is-in-wishlist'),
                variantID,
                item_list_name);
        });

        $('a.add-to-wish-list').on('click', function (e) {
            var eventAction = 'product_page';
            var product;
            var selectedVariant;
            var variantID = $(this).attr('data-pid') ? $(this).attr('data-pid') : $('.container.product-detail').attr('data-pid');

            if ($('[data-action="Search-Show"]').length > 0) {

                product = $(this).data('id');
                selectedVariant = $('.attribute .list-size .selected .value').text();
            } else if ($('[data-action="Cart-Show"]').length > 0) {
                let arr_info_product = $('.card.product-info').attr('data-pid').split('_');
                product = arr_info_product[0] + '_' + arr_info_product[1];
                selectedVariant = $('.line-item-attributes.item-list-size').attr('data-label');
            } else {
                let arr_info_product = variantID.split('_');
                product = arr_info_product[0] + '_' + arr_info_product[1];
                selectedVariant = $('.attribute .list-size .selected .value').text();
            }

            if (selectedVariant === '' || selectedVariant === null) {
                return;
            }

            var item_list_name = getPageType($('.js-page').data('action'), this);
            if($(this).parents().find('.quick-view-modal').css('display') === 'block'){
                item_list_name = 'quick_view';
            }

            trackForWish(
                $(e.target).closest('.add-to-wish-list').data('track-url'),
                $(this).hasClass('is-in-wishlist'),
                variantID,
                item_list_name);
        });

        $('.wishlist-row a.action-link.edit, .wishlist-row .side-image a').on('click', function (e) {
            var prodLayer = [];
            prodLayer.push(_this.generateProductTrackingModelWishlist($(e.target).closest('.wishlist-row')));
            prodLayer.position = $(e.target).closest('.product-row').attr('data-pos').split('.')[0];

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'productClick',
                    ecommerce: {
                        click: {
                            actionField: {
                                list: catListingSearch
                            },
                            products: prodLayer
                        }
                    }
                });
            }
        });

        $('.wishlist-row a.remove-from-wishlist').on('click', function (e) {
            //This is the remove event from wishlist

            var product = _this.generateProductTrackingModelWishlist($(e.target).closest('.wishlist-row'));

            const dataLayerGA4 = {
                event: 'remove_from_wishlist',
                ecommerce: {
                    currency: product.currency,
                    value: product.price - product.discount,
                    items: []
                }
            }
            dataLayerGA4.ecommerce.items.push(product);
            dataLayer.push(dataLayerGA4);
        });
    }

    newsletter() {
        $('.newsletterfooterform button').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'newsletter_subscription',
                event_action: 'start',
                event_label: 'footer'
            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });
    }

    socialshare() {
        $('.social-share-icons a').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'social',
                socialNetwork: $(this).children('svg').attr('class'),
                socialAction: 'share',
                socialTarget: window.location.href
            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        $('.social-links a').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'social',
                socialNetwork: $(this).attr('title').toLowerCase(),
                socialAction: 'click'
            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });
    }

    changecountry() {
        $('.select-country-content a').on('click', function (e) {
            var pageType = getPageType($('.js-page').data('action'), this);
            console.log(pageType);
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: pageType,
                event_action: 'change_country',
                event_label: $(this).data('locale')
            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        $('.select-lang-modal a').on('click', function (e) {
            var pageType = getPageType($('.js-page').data('action'), this);
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: pageType,
                event_action: 'change_language',
                event_label: $(this).data('locale')
            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });
    }

    homepage() {
        var promotionsAsset = [];
        var lookArray = [];
        var position = 0;
        var gridImageAndButton = $('.widget, .widget-1-col-video').not('.widget-3-col-img-shopbylook').find('[data-resize], a.button.editorial, a.js-data-layer-link').add($('.widget-customer-care').find('a.button.editorial'));
        var componentElements = document.getElementsByClassName('experience-component');

        //OLD METHOD TO PUSH IN DATALAYER ID AND NAME OF HOMEPAGE ELEMENT

        if (componentElements.length == 0) {
            $.each(gridImageAndButton, (itemIndex) => {
                promotionsAsset.push({
                    id: $(gridImageAndButton[itemIndex]).closest('[data-asset]').data('asset'),
                    name: $(gridImageAndButton[itemIndex]).closest('.widget').find('h2').text() || $(gridImageAndButton[itemIndex]).closest('.box').find('h5').text(),
                    creative: '',
                    position: itemIndex
                });
            });
        }
        //NEW METHOD TO PUSH IN DATALAYER ID AND NAME OF PAGE DESIGNER COMPONENT
        if (componentElements) {

            $.each(componentElements, (i) => {
                var componentID = $(componentElements[i]).contents('[data-id]').attr('data-id');
                var componentName = $(componentElements[i]).contents('[data-title]').attr('data-title');

                if (componentName === "undefined") {
                    componentName = $(componentElements[i]).contents('[data-asset]').attr('data-asset');
                }

                promotionsAsset.push({
                    id: componentID,
                    name: componentName,
                    creative: '',
                    position: i
                })
            });
        }


        gridImageAndButton.on('click', (e) => {
            if ($(e.currentTarget).closest('.widget-3-col-img-shopbylook').length == 0) {
                $.each(gridImageAndButton, (itemIndex) => {
                    if ($(gridImageAndButton[itemIndex])[0].dataset.resize == $(e.currentTarget)[0].dataset.resize && $(gridImageAndButton[itemIndex])[0].href == $(e.currentTarget)[0].href) {
                        position = itemIndex;
                    }
                });

                var dataLayerObject = {
                    event: 'promotionClick',
                    ecommerce: {
                        promoClick: {
                            promotions: [{
                                id: $(e.currentTarget).closest('[data-asset]').data('asset') || $(e.currentTarget).closest('[data-id]').attr('data-id'),
                                name: $(e.currentTarget).closest('[data-title]').attr('data-title') || $(e.currentTarget).closest('.widget').find('h2').text() || $(gridImageAndButton[position]).closest('.box').find('h5').text(),
                                creative: '',
                                position: position
                            }]
                        }
                    }
                };

                console.log(JSON.stringify(dataLayerObject));
                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push(dataLayerObject);
                }
            }
        });

        var widgetLook = $('.widget-3-col-img-shopbylook');
        // product look click
        $(widgetLook).on('click', '.owl-item a', function (e) {
            var $self = $(e.currentTarget);
            var lookName = $self.closest('.owl-item').find('h6')[0].innerText;
            var itemPosition = 0;
            var lookId = lookName;
            if ($self[0].href != '' && $self[0].href != 'undefined') {
                var hrefSplit = $self[0].href.split('/');
                var lookIdSplit = hrefSplit[hrefSplit.length - 1].split('-');
                var itemList = $('.widget-3-col-img-shopbylook').find('.owl-item a.button.editorial');
                lookId = lookIdSplit[lookIdSplit.length - 1].replace('.html', '');
                $.each(itemList, (itemIndex) => {
                    if ($(itemList[itemIndex])[0].href == $self[0].href) {
                        itemPosition = itemIndex;
                    }
                });
            }
            if (itemPosition == 9) {
                itemPosition = 1;
            } else if (itemPosition == 10) {
                itemPosition = 2;
            } else if (itemPosition = 11) {
                itemPosition = 3;
            }
            var dataLayerObject = {
                event: 'shop_by_look_click',
                ecommerce: {
                    click: {
                        actionField: {
                            list: 'shop_by_look_home_page'
                        },
                        products: [{
                            name: 'look|' + lookName,
                            id: lookId,
                            //   'price': '$$$total_price$$$',
                            brand: 'twinset milano',
                            category: '',
                            //   'list': 'shop_by_look_home_page',
                            position: itemPosition
                        }]
                    }
                }
            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        // product look impressions
        var widgetLookElements = $(widgetLook).find('.slide');
        $.each(widgetLookElements, (indexEl) => {
            var $self = $(widgetLookElements[indexEl]);
            var lookName = $($self).find('h6')[0].innerText;
            var aElem = $($self).find('a.button.editorial');
            var lookId = lookName;
            if (aElem[0].href != '' && aElem[0].href != 'undefined') {
                var hrefSplit = aElem[0].href.split('/');
                var lookIdSplit = hrefSplit[hrefSplit.length - 1].split('-');
                lookId = lookIdSplit[lookIdSplit.length - 1].replace('.html', '');
            }
            lookArray.push({
                name: 'look|' + lookName,
                id: lookId,
                //   'price': $$$total_price$$$,
                brand: 'twinset milano',
                category: '',
                list: 'shop_by_look_home_page',
                position: (indexEl + 1)
            });
        });

        if (typeof dataLayer !== 'undefined' && lookArray.length > 0) {
            dataLayer.push({
                event: 'shop_by_look_impression',
                ecommerce: {
                    impressions: lookArray
                }
            });
        }

        if (typeof dataLayer !== 'undefined' && promotionsAsset.length > 0) {
            dataLayer.push({
                event: 'promotionImpression',
                ecommerce: {
                    promoView: {
                        promotions: promotionsAsset
                    }
                }
            });
        }
    }

    plp() {
        var _this = this;
        $('div.main-menu a.nav-link').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'menu',
                event_action: e.target.id,
                event_label: 'only_first_level'
            };

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        $('.navbar h6 a').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'menu',
                event_action: $(e.target).parents('li.dropdown').children('a').attr('id'),
                event_label: e.target.id

            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        $('.menuitem ul a').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'menu',
                event_action: $(e.target).parents('li.dropdown').children('a').attr('id'),
                event_label: e.target.id

            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });
        $(document).on('click', '.product-tile a', function (e) {

            var id = $(e.target).closest('.product-tile').attr('data-pid');
            var listingProduct = listingProductsJson[$(e.target).closest('.product-tile').attr('data-pid')];
            if(!listingProduct){
                var productTile = $(e.target).closest('.product-tile');
                var impression = _this.generateProductTrackingModel(productTile);
                if ((listingProductsArrayForHomePage.findIndex(item => item.id === impression.id) == '-1')) {
                    listingProductsArrayForHomePage.push(impression);
                    listingProductsJson[productTile.attr('data-pid')] = impression;
                }

                listingProduct = listingProductsJson[$(e.target).closest('.product-tile').attr('data-pid')];
            }
            var productJson = _this.asyncProductsArray ? _this.asyncProductsArray.find(prod => prod.id === id) : listingProduct;

            if(!productJson && listingProduct)
                productJson = listingProduct;

            if (productJson) {

                let list;
                if (typeof catListingSearch !== 'undefined') {
                    list = catListingSearch;
                }

                if (pageTypeForJS === 'cart') {
                    list = 'related_products_cart';
                }
                // triggered both here and enhancedseo.js - disabled here if list is not set due to duplicate tracking TR-1476
                // if (typeof dataLayer !== 'undefined' && list) {
                if (typeof dataLayer !== 'undefined') {

                    let categories = productJson.category ? productJson.category.split("/") : [];
                    let colorName = $(e.currentTarget).data('display-value') ? $(e.currentTarget).data('display-value') : productJson.colorName;

                    if ($(this).hasClass('quickview')) {
                        dataLayer.push({
                            event: 'view_item',
                            where: 'quick_view',
                            ecommerce: {
                                currency: currentCurrency,
                                items: [
                                    {
                                        item_id: productJson.id,
                                        item_name: productJson.name,
                                        currency: currentCurrency,
                                        discount: productJson.discount,
                                        item_brand: productJson.brand,
                                        item_category: categories.length > 0 ? categories[0] : '',
                                        item_category2: categories.length > 1 ? categories[1] : '',
                                        item_category3: categories.length > 2 ? categories[2] : '',
                                        item_list_name: productJson.list,
                                        item_variant: colorName,
                                        price: parseFloat((Number(productJson.price) - Number(productJson.discount)).toFixed(2)),
                                        quantity: 1,
                                        item_availability: productJson.available,
                                        item_discount_tag: productJson.discount !== 0 ? 'on_sale' : 'not_on_sale',
                                        available_size_percentage: productJson.available_size_percentage,
                                        item_size: '',
                                        item_variant_v2: productJson.variantID,
                                        item_url: productJson.url,
                                        item_img: productJson.imageUrl
                                    }
                                ]
                            }
                        });
                    }else{
                        dataLayer.push({
                            event: 'select_item',
                            ecommerce: {
                                currency: currentCurrency,
                                items: [
                                    {
                                        item_id: productJson.id,
                                        item_name: productJson.name,
                                        currency: currentCurrency,
                                        discount: productJson.discount,
                                        index: productJson.position,
                                        item_brand: productJson.brand,
                                        item_category: categories.length > 0 ? categories[0] : '',
                                        item_category2: categories.length > 1 ? categories[1] : '',
                                        item_category3: categories.length > 2 ? categories[2] : '',
                                        item_list_name: productJson.list,
                                        item_variant: colorName,
                                        price: parseFloat((Number(productJson.price) - Number(productJson.discount)).toFixed(2)),
                                        quantity: 1,
                                        item_availability: productJson.available,
                                        item_discount_tag: productJson.discount !== 0 ? 'on_sale' : 'not_on_sale',
                                        available_size_percentage: productJson.available_size_percentage,
                                        item_size: '',
                                        item_url: productJson.url,
                                        item_img: productJson.imageUrl
                                    }
                                ]
                            }
                        });
                    }


                }
            }
        });
    }

    breadcrumbs() {
        $('.breadcrumbs-nav a').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'breadcrumbs',
                event_action: $(this).data('event-action'),
                event_label: $(this).data('event-label')
            };

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });
    }

    filters() {
        $('div.refinements').on('refinements:update', function (e, data) {
            var clickedFilter = $(data.clickedFilter) || null;
            var selectedSortOption = $('.plp-sort-order .current').length > 0 ?
                $('.plp-sort-order .current').data('id') : '-';


            if(clickedFilter && $('span.selected').length > 0){
                var dataLayerObject = {
                    event: 'asyncAction',
                    gaHitType: 'event',
                    event_category: 'filters',
                    event_action: 'apply',
                    attribute_group: clickedFilter.data('id'),
                    attribute_value: clickedFilter.find('span').text().trim(),
                    filter_sort: selectedSortOption
                };

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push(dataLayerObject);
                }
            } else if ($('span.selected').toArray().map(filter => filter.innerText).join('/')) {
                var dataLayerObject = {
                    event: 'asyncAction',
                    gaHitType: 'event',
                    event_category: 'filters',
                    event_action: 'apply',
                    event_label: $('span.selected').toArray().map(filter => filter.innerText).join('/')
                };

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push(dataLayerObject);
                }
            }
        });

        $('.plp-header-bottom-rocker a.reset').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'filters',
                event_action: 'reset'
            };

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        $(document).on('click', '.plp-sort-order a', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'filters',
                event_action: 'sort_by',
                attribute_group: '-',
                attribute_value: '-',
                filter_sort: this.parentNode.dataset.id
            };

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        $('.plp-header-content-top button.close').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'filters',
                event_action: 'close'
            };

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        $('button.filter-results').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'filters',
                event_action: 'open'
            };

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        $('.select-categories .sub-categories a.sub-category-link').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'fascia_categorie',
                event_action: (($(this).data('level') == '3') ? 'third_level' : 'second_level'),
                event_label: $(this).html()
            };

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });
    }

    checkout() {
        $('div#store-picker button').on('click', function (e) {
            var dataLayerObject = {
                event: 'asyncAction',
                gaHitType: 'event',
                event_category: 'find_a_store',
                event_action: $('#store-picker-autocomplete').val().split(', ').slice(-1)[0],
                event_label: `${$('#store-picker-autocomplete').val().split(', ')[0]}|${$('#store-picker-range').val()}km`
            };

            console.log(JSON.stringify(dataLayerObject));
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(dataLayerObject);
            }
        });

        // code moved and modified in checkout.js

        // $('.single-shipping .tab-nav a').on('click', function (e) {
        //     var dataLayerObject = {
        //         'event': 'checkoutOption',
        //         'ecommerce': {
        //             'checkout_option': {
        //                 'actionField': {
        //                     'step': 1,
        //                     'option': $(e.target).parents('li').data('target')
        //                 }
        //             }
        //         }
        //     };

        //     actionField.option = $(e.target).parents('li').data('target');
        //     console.log(JSON.stringify(dataLayerObject));
        //     if(typeof dataLayer !== 'undefined'){
        //         dataLayer.push(dataLayerObject);
        //     }
        // });

        // $('.payment-options input[type="radio"]').on('click', function (e) {
        //     var dataLayerObject = {
        //         'event': 'checkoutOption',
        //         'ecommerce': {
        //             'checkout_option': {
        //                 'actionField': {
        //                     'step': 2,
        //                     'option': this.id.toLowerCase()
        //                 }
        //             }
        //         }
        //     };

        //     actionField.option = this.id.toLowerCase();
        //     console.log(JSON.stringify(dataLayerObject));
        //     if(typeof dataLayer !== 'undefined'){
        //         dataLayer.push(dataLayerObject);
        //     }
        // });
    }

    passwordInteractionEvent(actionName){
        dataLayer.push({
            event: "GAevent",
            eventID: "002",
            eventCategory: "user_interaction",
            eventAction: "password-interaction",
            eventLabel: actionName,
            eventElement01: "-",
            eventElement02: "-",
            eventElement03: "-"
        })
    }
}

function getPageType(pageAction, element){
    var item_list_name = ''
    if (pageAction === 'Home-Show') {
        item_list_name = 'homepage';
    } else if (pageAction ===  'Search-Show') {
        item_list_name = $('.js-page').data('querystring').includes('cgid') ? 'category_listing' : 'search_results';
    }else if (pageAction ===  'Product-Show') {
        item_list_name = $(element).parents('.recommendations').length > 0 ? 'related_products' : 'pdp';
    }else if (pageAction ===  'Cart-Show') {
        item_list_name = $(element).parents('.recommendations').length > 0 ? 'related_products' : 'cart';
    }

    return item_list_name;
}

function trackForWish(urlProductVariant, isInWishlist, variantID, item_list_name) {

    $.ajax({
        url: urlProductVariant,
        type: 'get',
        context: this,
        dataType: 'json',
        success: (data) => {
            let discount = '0.00';
            let originalPrice = data.product.price.list;
            let finalPrice = data.product.price.sales;

            if(data.product.price.type === 'range'){
                finalPrice = data.product.price.min.sales;
                originalPrice = data.product.price.min.list ? data.product.price.min.list : finalPrice;
            }

            if (originalPrice)
                discount = ((parseFloat(originalPrice.decimalPrice) - parseFloat(finalPrice.decimalPrice)).toFixed(2)).toString();

            let currency = finalPrice.currency;
            let categories = data.product.categoryPath.split("/");
            let variant = '';
            let pidSplit = data.queryString.split('_');
            if (pidSplit.length > 1) {
                variant = pidSplit[1];
            }

            var colorID = variantID.split('_')[1];
            var size = variantID.split('_')[2];

            var colorName = colorID;
            data.product.variationAttributes[0].values.filter((obj) => {
                if(obj.id === colorID){
                    colorName = obj.displayValue;
                }
            });

            const dataLayerGA4 = {
                event: isInWishlist ? 'remove_from_wishlist' : 'add_to_wishlist',
                ecommerce: {
                    currency: currency,
                    where: item_list_name,
                    value: Number(finalPrice.decimalPrice),
                    items: [
                        {
                            item_id: data.product.id,
                            item_name: data.product.productName,
                            currency: currency,
                            discount: Number(discount),
                            item_brand: 'twinset milano',
                            item_category: categories.length > 0 ? categories[0] : '',
                            item_category2: categories.length > 1 ? categories[1] : '',
                            item_category3: categories.length > 2 ? categories[2] : '',
                            item_list_name: item_list_name,
                            item_variant: colorName,
                            price: originalPrice
                                ? parseFloat((Number(originalPrice.decimalPrice) - Number(discount)).toFixed(2))
                                : parseFloat((Number(finalPrice.decimalPrice) - Number(discount)).toFixed(2)),
                            quantity: data.product.selectedQuantity,
                            item_availability: data.product.availability.inStock ? 'in_stock' : 'out_of_stock',
                            item_discount_tag: discount !== '0.00' ? 'on_sale' : 'not_on_sale',
                            available_size_percentage: Number(data.product.available_size_percentage),
                            item_size: size,
                            item_variant_v2: variantID,
                            item_url: data.product.masterUrl,
                            item_img: data.product.images.large[0].url
                        }
                    ]
                }
            }
            dataLayer.push(dataLayerGA4);
        },
        error: (err) => {
        }
    });
}

const Seo = new SEO();
export default Seo;



// WEBPACK FOOTER //
// ./assets/scripts/components/seo.js